import React, { useState, useEffect } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { useUser } from "../../../context/user-context";
import ClipLoader from "react-spinners/ClipLoader";
import useAuthAxios from "../../../utils/baseAxios";
import { useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { API } from "../../../constants/api";
import { errorMessage } from "../../../utils/errorMessage";

const GenerateStatament = ({ setOpenStatement, setOpenSuccess }: any) => {
  const [statementFor, setStatementFor] = useState<string>("all");
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const { userDetails } = useUser();
  const [disabled, setDisabled] = useState<boolean>(false);
  const axiosInstance = useAuthAxios();
  const isValidEmail = (email: string) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  useEffect(() => {
    const hasUserEmail = !!userDetails?.user?.email?.address;
    const emailToUse = hasUserEmail ? userDetails.user.email.address : email;

    if (!hasUserEmail && email && !isValidEmail(email)) {
      toast.error("Please enter a valid email address");
      setDisabled(true);
      return;
    }

    if (startDate && endDate && emailToUse) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [startDate, endDate, email, userDetails]);

  const handleStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEndDate(e.target.value);
  };

  const handleGenerate = async (data: any) => {
    const response = await axiosInstance.post(
      API.generateAccountStatement,
      data
    );
    return response.data;
  };
  const completeGenerate = useMutation({
    mutationFn: handleGenerate,
    onSuccess: (r) => {
      toast.success(r.message);
      setTimeout(() => {
        setOpenSuccess(true);
        setOpenStatement(false);
      }, 1500);
    },
    onError: (error: any) => {
      toast.error(
        errorMessage((error?.data as any)?.message || String(error?.data))
      );
    },
  });
  const generateStatement = () => {
    const data = {
      recipient: userDetails?.user?.email?.address || email,
      source: statementFor,
      start_date: startDate,
      end_date: endDate,
    };
    completeGenerate.mutate(data);
  };

  return (
    <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="w-full flex justify-start gap-6 items-center">
          <button
            onClick={() => {
              setOpenStatement(false);
            }}
          >
            <BsArrowLeft className="text-black dark:text-white text-[20px]" />
          </button>
          <h4 className="text-gray-900 dark:text-gray-100 font-sora font-semibold text-[20px]">
            Generate Statement
          </h4>
        </div>
        <div className="w-full mt-8">
          <div>
            <label className="text-gray-700   dark:text-gray-300">
              Statement for
            </label>
            <select
              onChange={(e) => setStatementFor(e.target.value)}
              value={statementFor}
              className="w-full bg-transparent  dark:border-[#095B97] text-gray-700 dark:text-gray-300 h-[48px] mt-2  outline-none text-[15px] border border-gray-400  pr-2 pl-2  rounded-lg"
            >
              <option value="all">All transactions</option>
              <option value="utility_bills">Bill payment</option>
              <option value="crypto_withdrawals">Wallet Withdrawal</option>
              <option value="deposits">Wallet Deposits</option>
              <option value="rewards">Rewards</option>
              <option value="sell">Sell</option>
            </select>
          </div>
          <div className="mt-6">
            <label className="text-gray-700   dark:text-gray-300">
              Start date
            </label>
            <input
              type="date"
              value={startDate}
              onChange={handleStartDateChange}
              max={new Date().toISOString().split("T")[0]}
              className="w-full bg-transparent    dark:border-[#095B97] text-gray-700 dark:text-gray-300 h-[48px] mt-2 outline-none text-[15px] border border-gray-400  pr-2 pl-2  rounded-lg"
            />
          </div>
          <div className="mt-6">
            <label className="text-gray-700   dark:text-gray-300">
              End date
            </label>
            <input
              type="date"
              value={endDate}
              onChange={handleEndDateChange}
              min={startDate || undefined}
              max={new Date().toISOString().split("T")[0]}
              className="w-full bg-transparent    dark:border-[#095B97] text-gray-700 dark:text-gray-300 h-[48px] mt-2 outline-none text-[15px] border border-gray-400  pr-2 pl-2  rounded-lg"
            />
          </div>
          <div className="mt-6">
            <label className="text-gray-700   dark:text-gray-300">
              Send to{" "}
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={`${userDetails?.user?.email?.address}`}
              className="w-full bg-transparent    dark:border-[#095B97] text-gray-700 dark:text-gray-300 h-[48px] mt-2 outline-none text-[15px] border border-gray-400   pr-2 pl-2  rounded-lg"
            />
          </div>
          <button
            disabled={disabled}
            onClick={generateStatement}
            className={
              disabled
                ? "w-full h-[52px] flex justify-center items-center font-manrope mx-auto text-gray-200  rounded-xl bg-gray-400 dark:bg-[#8f9294]  mt-8"
                : "w-full h-[52px] flex justify-center items-center font-manrope mx-auto  font-medium rounded-xl text-white bg-secondary_button mt-8"
            }
          >
            {completeGenerate.isPending ? (
              <ClipLoader color="#FFFFFF" size={30} />
            ) : (
              "Confirm"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default GenerateStatament;
